import React from 'react';
import ReactDOM from 'react-dom';
import TripGroupSelectorModal, { TripGroup } from './TripGroupSelectorModal';

interface SelectTripGroupsModalProps {
  currentSelectedTripGroupIds?: string[];
  includeArchiveGroups?: boolean;
  responseData?: any[];
}

const selectTripGroupsModal = (
  currentSelectedTripGroupIds: string[] = [],
  includeArchiveGroups: boolean = false,
  responseData: any[] = []
): Promise<{ tripGroups: TripGroup[], includeArchiveGroups: boolean }> => {
  return new Promise((resolve, reject) => {
    const modalRoot = document.createElement('div');
    document.body.appendChild(modalRoot);

    const closeModal = () => {
      ReactDOM.unmountComponentAtNode(modalRoot);
      if (document.body.contains(modalRoot)) {
        document.body.removeChild(modalRoot);
      }
    };

    const handleSubmit = (data: { tripGroups: TripGroup[], includeArchiveGroups: boolean }) => {
      closeModal();
      resolve(data);
    };
    ReactDOM.render(
      <TripGroupSelectorModal
        isOpen={true}
        onRequestClose={closeModal}
        selectedTripGroupIds={currentSelectedTripGroupIds}
        includeArchiveGroups={includeArchiveGroups}
        onSubmit={handleSubmit}
        responseData={responseData}
      />,
      modalRoot
    );
  });
};

export default selectTripGroupsModal;